<nav class="nav" [class.scrolled]="scrolled()" [class.menu-open]="menuOpen()">
  <a class="nav-brand" [routerLink]="routes.home" (click)="closeMenu()">
    <img src="/assets/img/logo.svg" alt="" width="34" height="34" />
    <div class="nav-brand-text">
      <div class="nav-brand-name">{{ 'nav.logoName' | translate }}</div>
      <div class="nav-brand-tag">{{ 'nav.logoMeta' | translate }}</div>
    </div>
  </a>

  <div class="nav-links">
    <a class="nav-link" [routerLink]="routes.home" fragment="about">{{ 'nav.links.about' | translate }}</a>
    <a class="nav-link" [routerLink]="routes.home" fragment="offerings">{{ 'nav.links.offerings' | translate }}</a>
    <a class="nav-link" [routerLink]="routes.home" fragment="gallery">{{ 'nav.links.gallery' | translate }}</a>
    <a class="nav-link" [routerLink]="routes.home" fragment="info">{{ 'nav.links.info' | translate }}</a>
    <button ppcButton size="sm" type="button" (click)="onAccount()">{{ accountLabelKey() | translate }}</button>
    <div class="nav-lang" role="group" [attr.aria-label]="'nav.languageLabel' | translate">
      @for (option of langOptions(); track option.code; let last = $last) {
        <button
          type="button"
          class="nav-lang-option"
          [class.active]="option.code === currentLang()"
          [attr.aria-pressed]="option.code === currentLang()"
          (click)="switchLang(option.code)"
        >
          {{ option.label }}
        </button>
        @if (!last) {
          <span class="nav-lang-separator" aria-hidden="true">/</span>
        }
      }
    </div>
  </div>

  <button
    type="button"
    class="nav-burger"
    (click)="toggleMenu()"
    [attr.aria-expanded]="menuOpen()"
    [attr.aria-label]="'nav.menuAria' | translate"
  >
    <span class="nav-burger-bar"></span><span class="nav-burger-bar"></span><span class="nav-burger-bar"></span>
  </button>
</nav>

@if (menuOpen()) {
  <div class="nav-menu">
    <div ppcEyebrow mark class="nav-menu-eyebrow">{{ 'nav.menuHeader' | translate }}</div>
    <nav class="nav-menu-list">
      <a class="nav-menu-link" [routerLink]="routes.home" fragment="about" (click)="closeMenu()">{{
        'nav.links.about' | translate
      }}</a>
      <a class="nav-menu-link" [routerLink]="routes.home" fragment="offerings" (click)="closeMenu()">{{
        'nav.links.offerings' | translate
      }}</a>
      <a class="nav-menu-link" [routerLink]="routes.home" fragment="gallery" (click)="closeMenu()">{{
        'nav.links.gallery' | translate
      }}</a>
      <a class="nav-menu-link" [routerLink]="routes.home" fragment="info" (click)="closeMenu()">{{
        'nav.links.info' | translate
      }}</a>
    </nav>

    <button ppcButton size="lg" type="button" class="nav-menu-actions" (click)="onAccount()">
      <span>{{ accountLabelKey() | translate }}</span>
      <span class="nav-menu-actions-arrow">{{ 'nav.menuCtaArrow' | translate }}</span>
    </button>

    <div class="nav-menu-footer">
      <div class="nav-menu-info">
        <div class="nav-menu-info-key">{{ 'nav.addressLabel' | translate }}</div>
        <div>{{ 'company.address' | translate }}</div>
      </div>
      <div class="nav-menu-info">
        <div class="nav-menu-info-key">{{ 'nav.contactLabel' | translate }}</div>
        <div>
          <a [href]="'tel:' + ('company.phoneHref' | translate)">{{ 'company.phone' | translate }}</a
          ><br />
          <a [href]="'mailto:' + ('company.email' | translate)">{{ 'company.email' | translate }}</a>
        </div>
      </div>
      <div class="nav-menu-socials">
        <a class="nav-menu-social" [href]="'company.facebook' | translate" target="_blank" rel="noopener">{{
          'nav.social.facebook' | translate
        }}</a>
        <a class="nav-menu-social" [href]="'company.instagram' | translate" target="_blank" rel="noopener">{{
          'nav.social.instagram' | translate
        }}</a>
      </div>
      <div class="nav-menu-established">{{ 'nav.estPrefix' | translate }}{{ 'company.founded' | translate }}</div>
      <div class="nav-lang" role="group" [attr.aria-label]="'nav.languageLabel' | translate">
        @for (option of langOptions(); track option.code; let last = $last) {
          <button
            type="button"
            class="nav-lang-option"
            [class.active]="option.code === currentLang()"
            [attr.aria-pressed]="option.code === currentLang()"
            (click)="switchLang(option.code)"
          >
            {{ option.label }}
          </button>
          @if (!last) {
            <span class="nav-lang-separator" aria-hidden="true">/</span>
          }
        }
      </div>
    </div>
  </div>
}
